Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryDetailView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_detail']
  className: 'summary-detail'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary
    new ClipboardJS('.summary-copy-id')

  render: ->
    @$el.html @template
      timestamp: @_timestampDisplay()
      timestampHover: @_timestampHoverDisplay()
      id: @ticketSummary.get 'id'
      interactionCount: @ticketSummary.get 'interaction_count'
      priority: @ticketSummary.get 'priority'
      status:
        name: @_statusDisplay()
        iconElement: @_statusIcon()
      assignment:
        class: @_assignment()
        name: @_operatorDisplay()
        icon: @_assignmentIcon()
    @

  _timestampDisplay: ->
    @_latestContentDate().format 'DD/MM/YYYY - HH:mm'

  _timestampHoverDisplay: ->
    @_latestContentDate().format 'DD/MM/YYYY HH:mm Z'

  _latestContentDate: ->
    @latestContentDate ||= Date.create @ticketSummary.get('latest_content_date')

  _statusDisplay: ->
    statusCode = @ticketSummary.get('status').toLowerCase().replace(' ', '_')
    I18n.t "customer.dashboard.conversations.status.#{statusCode}"

  _statusIcon: ->
    statusSlug = _.string.slugify @ticketSummary.get('status')
    return @_svgStatusIcon(statusSlug) if Object.keys(@_statusIconNames).includes(statusSlug)
    @_fontawesomeStatusIcon(statusSlug)

  _svgStatusIcon: (slug) ->
    name = @_statusIconNames[slug]
    image = window.image_path "icons/#{name}.svg"
    "<svg class='icon'>
       <use xlink:href='#{image}##{name}'></use>
     </svg>"

  _fontawesomeStatusIcon: (slug) ->
    "<i class='#{@_statusIconClasses[slug]} summary-status-#{slug}'></i>"

  _statusIconNames:
    'assigned': 'status-assigned'
    'not-assigned': 'status-not-assigned'

  _statusIconClasses:
    'closed': 'fa fa-check-circle'
    'pending': 'fa fa-clock-o'
    'reopen': 'fa fa-refresh'

  _operatorDisplay: ->
    code = @ticketSummary.get 'chatbot_code'
    if code then "Chatbot #{code}" else @ticketSummary.get 'assigned_to_name'

  _assignment: ->
    if @ticketSummary.get 'assigned_to_id'
      'assigned-user'
    else if @ticketSummary.get 'users_group_id'
      'assigned-group'
    else
      'unassigned'

  _assignmentIcon: ->
    @_assignmentIconClasses[@_assignment()]

  _assignmentIconClasses:
    'unassigned': 'fa fa-user-o'
    'assigned-user': 'fa fa-user'
    'assigned-group': 'fa fa-users'
